interface BaseMessageScheme {
  message_type: string
}

interface ResizeMessageScheme extends BaseMessageScheme {
  message_type: 'resize'
  frameHeight: number
  url: string
  stage: string
}

interface OpenPopupMessageScheme extends BaseMessageScheme {
  message_type: 'open_popup'
  url: string
}

interface ClosePopupMessageScheme extends BaseMessageScheme {
  message_type: 'close_popup'
}

interface InitCartMessageScheme extends BaseMessageScheme {
  message_type: 'init_cart'
  count: number
  link: string
}

interface UpdateCartMessageScheme extends BaseMessageScheme {
  message_type: 'update_cart'
  count: number
  link: string
}

type MessageScheme =
  | ResizeMessageScheme
  | OpenPopupMessageScheme
  | ClosePopupMessageScheme
  | InitCartMessageScheme
  | UpdateCartMessageScheme

function sendResize(stage = 'other') {
  sendData({
    message_type: 'resize',
    frameHeight: document.body.scrollHeight,
    url: `${useHost()}${useRoute().fullPath}`,
    stage,
  })
}

function sendData(data: MessageScheme) {
  setTimeout(() => {
    window.parent?.postMessage(data, '*')
  }, 0)
}

function initBridge() {
  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach(() => {
      sendResize('observer')
    })
  })
  resizeObserver.observe(document.body)
  window.addEventListener('resize', () => sendResize('event'), true)
  sendResize('init')
}

export function useFrameBridge() {
  return {
    initBridge,
    sendResize,
    sendData,
  }
}
